.googleButton {
  width: 100%;
  height: 3rem;

  img {
    margin-right: 0.6875rem;

    @media (min-width: 769px) {
      margin-right: 0.75rem;
    }
  }
}
